/* eslint-disable react/no-danger, max-len , no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Head from 'next/head';
import { useRouter } from 'next/router';
import isEmpty from 'lodash.isempty';
import { theme } from 'config';
import { setSqzlCookieConsent } from 'utils/tracking';
import { sentryInit } from 'utils/sentry';
import { AppContext } from 'context/AppContext';

import Layout from 'components/Layout';

import 'styles/index.css';

sentryInit();

function Application({ Component, pageProps, err }) {
  const gtmId = pageProps.sitesettings?.gtmId || '';
  const [appState, setAppState] = useState({
    showWizard: false,
    wizardProps: {},
  });

  const router = useRouter();
  useEffect(() => {
    const OnRouteChange = () => {
      setSqzlCookieConsent();
    };

    router.events.on('routeChangeComplete', OnRouteChange);
    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeComplete', OnRouteChange);
    };
  }, []);

  return (
    <>
      <Head>
        {/* Google tag manager */}
        {gtmId && (
          <script
            dangerouslySetInnerHTML={{
              __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');`,
            }}
          />
        )}
        {process.env.SQUEEZELY_MERCHANT_ID && (
          <script
            dangerouslySetInnerHTML={{
              __html: `(function(s,q,z,l,y){s._sqzl=s._sqzl||[];l=q.createElement('script'),
              y=q.getElementsByTagName('script')[0];l.async=1;l.type='text/javascript';
              l.defer=true;l.src=z;y.parentNode.insertBefore(l,y)})
              (window,document,'https://squeezely.tech/tracker/${process.env.SQUEEZELY_MERCHANT_ID}/sqzl.js');

              window._sqzl = window._sqzl || [];`,
            }}
          />
        )}
        {/* Google tag manager */}
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      </Head>
      <AppContext.Provider value={{ ...appState, updateAppState: setAppState }}>
        <ThemeProvider theme={theme}>
          <Layout gtmId={gtmId} noPageData={isEmpty(pageProps)} {...pageProps}>
            <Component {...pageProps} err={err} />
          </Layout>
        </ThemeProvider>
      </AppContext.Provider>
    </>
  );
}

Application.defaultProps = {
  err: null,
  pageProps: {
    sitesettings: {
      gtmId: '',
    },
  },
};

Application.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.shape({
    sitesettings: PropTypes.shape({
      gtmId: PropTypes.string,
    }),
  }),
  err: PropTypes.shape({}),
};

export default Application;
